<template>
  <div>
    <section>
      <div class="reachus">
        <div class="containerWrapper">
          <div class="reachus__wrapper">
            <div class="reachus__left">
              <h4>Follow us for updates</h4>
              <ul>
                <li>
                  <a href=" https://twitter.com/lftechnology" target="_blank">
                    <svg
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M48 9.117C46.215 9.9 44.313 10.419 42.33 10.671C44.37 9.453 45.927 7.539 46.659 5.232C44.757 6.366 42.657 7.167 40.419 7.614C38.613 5.691 36.039 4.5 33.231 4.5C27.783 4.5 23.397 8.922 23.397 14.343C23.397 15.123 23.463 15.873 23.625 16.587C15.444 16.188 8.205 12.267 3.342 6.294C2.493 7.767 1.995 9.453 1.995 11.268C1.995 14.676 3.75 17.697 6.366 19.446C4.785 19.416 3.234 18.957 1.92 18.234C1.92 18.264 1.92 18.303 1.92 18.342C1.92 23.124 5.331 27.096 9.804 28.011C9.003 28.23 8.13 28.335 7.224 28.335C6.594 28.335 5.958 28.299 5.361 28.167C6.636 32.064 10.254 34.929 14.556 35.022C11.208 37.641 6.957 39.219 2.355 39.219C1.548 39.219 0.774 39.183 0 39.084C4.359 41.895 9.525 43.5 15.096 43.5C33.204 43.5 43.104 28.5 43.104 15.498C43.104 15.063 43.089 14.643 43.068 14.226C45.021 12.84 46.662 11.109 48 9.117Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="48" height="48" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/lftechnology"
                    target="_blank"
                    ><svg
                      viewBox="0 0 45 45"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M29.9944 7.47187H34.1025V0.316875C33.3937 0.219375 30.9562 0 28.1175 0C22.1944 0 18.1369 3.72562 18.1369 10.5731V16.875H11.6006V24.8737H18.1369V45H26.1506V24.8756H32.4225L33.4181 16.8769H26.1487V11.3662C26.1506 9.05437 26.7731 7.47187 29.9944 7.47187V7.47187Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="45" height="45" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/lftechnology"
                    target="_blank"
                    ><svg
                      viewBox="0 0 119 119"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.1899 6.04276C9.0093 6.04276 3.66065 11.4146 3.66065 18.4751C3.66065 25.3796 8.84997 30.9046 16.876 30.9046H17.0313C25.3719 30.9046 30.5626 25.3796 30.5626 18.4751C30.4066 11.4146 25.3719 6.04276 17.1899 6.04276V6.04276Z"
                      />
                      <path
                        d="M5.07424 40.7283H28.9896V112.679H5.07424V40.7283Z"
                      />
                      <path
                        d="M87.6907 39.0396C74.7892 39.0396 66.1381 51.1628 66.1381 51.1628V40.7283H42.222V112.679H66.1367V72.4988C66.1367 70.3478 66.2927 68.2002 66.9246 66.662C68.6534 62.3667 72.5878 57.9169 79.1948 57.9169C87.8487 57.9169 91.3098 64.515 91.3098 74.1875V112.679H115.223V71.4237C115.223 49.3236 103.424 39.0396 87.6907 39.0396V39.0396Z"
                      />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
            <div class="reachus__right">
              <h4>Reach us out</h4>
              <span>You can reach us out anytime, please dont hesitate.</span>
              <div>
                <a href="mailto:syntax@lftechnology.com">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="25px"
                    width="25px"
                    viewBox="0 0 20 20"
                    fill="white"
                  >
                    <path
                      d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                    />
                    <path
                      d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                    /></svg
                  >&nbsp;Email Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer>
      <div class="pageFooter">
        <div class="containerWrapper pageFooter__wrapper">
          <span>Organized by</span>
          <a href="https://www.lftechnology.com/" target="_blank">
            <img src="../assets/logo.svg" alt="leapfrog logo" />
          </a>
        </div>
      </div>
      <div class="pageFooter__footNote">
        <hr />
        <div>
          <p>© Copyright 2021, Leapfrog Technology, Inc.</p>
          <p>|</p>
          <p>
            <a href="mailto:syntax@lftechnology.com">syntax@lftechnology.com</a>
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer .pageFooter {
  color: var(--text-white);
  font-weight: normal;
  font-size: 1rem;
}

.reachus__wrapper h4 {
  font-size: 2rem;
}

.pageFooter__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 25px;
  margin-bottom: 2rem;
}
.pageFooter {
  margin-top: 3.4rem;
}

footer .pageFooter svg,
.pageFooter__footNote {
  text-align: center;
  cursor: pointer;
}

.footer {
  background-color: var(--bg-black);
}

.reachus {
  background-image: linear-gradient(
    90deg,
    #18fb8e,
    #00cf6b,
    rgb(0, 145, 75),
    #00cc69
  );
  background-size: 300% 100%;
  animation: animateBackground 10s infinite ease-in-out;
  padding: 4rem 0rem;
  margin: 9rem 0rem;
}
@keyframes animateBackground {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}
.reachus__wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;
  align-items: center;
}
.reachus__left ul {
  display: flex;
}

.reachus__left ul li {
  background-color: var(--bg-black);
  margin-right: 20px;
  padding: 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.reachus__left ul li a {
  display: inline-flex;
  align-items: center;
}

.reachus__left ul li a > svg {
  width: 23px;
  fill: var(--text-white);
}

.reachus__left ul li a:hover > svg {
  fill: var(--primary-color);
}

.reachus__right p {
  font-size: 1.2rem;
  font-weight: 700;
}

.reachus__right > div a {
  display: inline-flex;
  align-items: center;
  margin-top: 1rem;
  background-color: var(--bg-black);
  margin-right: 20px;
  padding: 10px;
  cursor: pointer;
  color: var(--text-white);
  font-weight: bolder;
  padding: 0.7rem 1.5rem;
}

.reachus__right > div a:hover > svg {
  fill: var(--primary-color);
  color: var(--primary-color);
}

.reachus__right > div a:hover {
  color: var(--primary-color);
}

.reachus__right span {
  color: var(--bg-black);
}

.pageFooter__footNote {
  background-color: var(--bg-black);
  padding-top: 60px;
}

.pageFooter__footNote hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid var(--light-grey);
  padding: 0;
}

.pageFooter__footNote > div {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 20px 0px;
}

.pageFooter__footNote > div p,
.pageFooter__footNote a {
  color: var(--color-grey);
  text-decoration: none;
}

.pageFooter__footNote a:hover {
  color: var(--primary-color);
}
@media (max-width: 576px) {
  .pageFooter__footNote > div p:nth-child(2) {
    display: none;
  }
  .reachus__wrapper {
    grid-template-columns: repeat(1, 1fr);
  }
  .reachus {
    text-align: center;
  }
  .reachus__left ul {
    display: inline-flex;
  }
}
</style>
